import { notifications } from '@mantine/notifications';

const SOUND_GAP_MS = 1500;
let lastSound = 0;
let audio: AudioContext | null = null;

export const chatDesktopPermission = (): NotificationPermission | 'unsupported' => (typeof window !== 'undefined' && 'Notification' in window ? Notification.permission : 'unsupported');

export const chatDesktopRequest = async (): Promise<NotificationPermission | 'unsupported'> => {
    if (chatDesktopPermission() === 'unsupported') return 'unsupported';
    try {
        return await Notification.requestPermission();
    } catch {
        return Notification.permission;
    }
};

export const chatPlaySound = (): void => {
    const now = Date.now();
    if (now - lastSound < SOUND_GAP_MS) return;
    lastSound = now;
    try {
        const Context = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
        if (!Context) return;
        audio = audio ?? new Context();
        const start = audio.currentTime;
        [880, 1320].forEach((frequency, index) => {
            const oscillator = audio!.createOscillator();
            const gain = audio!.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.value = frequency;
            gain.gain.setValueAtTime(0.0001, start + index * 0.09);
            gain.gain.exponentialRampToValueAtTime(0.08, start + index * 0.09 + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + index * 0.09 + 0.16);
            oscillator.connect(gain).connect(audio!.destination);
            oscillator.start(start + index * 0.09);
            oscillator.stop(start + index * 0.09 + 0.18);
        });
    } catch {
        return;
    }
};

export const chatShowToast = (key: string, title: string, body: string, onOpen: () => void): void => {
    const id = `chat-${key}`;
    notifications.hide(id);
    notifications.show({
        id,
        title,
        message: body,
        color: 'brand',
        autoClose: 6000,
        withBorder: true,
        className: 'bd-chat-toast',
        style: { cursor: 'pointer' },
        onClick: () => {
            notifications.hide(id);
            onOpen();
        },
    });
};

export const chatShowDesktop = (key: string, title: string, body: string, onOpen: () => void): void => {
    if (chatDesktopPermission() !== 'granted') return;
    try {
        const notice = new Notification(title, { body, tag: `bd-chat-${key}`, icon: '/icons/icon-192.png', silent: true });
        notice.onclick = () => {
            window.focus();
            onOpen();
            notice.close();
        };
    } catch {
        return;
    }
};
